import React, {
  Children, cloneElement, useEffect, useState, useCallback,
} from 'react';

const idGenerator = (function* clickId() {
  let id = 0;
  while (true) {
    id += 1;
    yield id;
  }
}());

/**
 * Use this component to listen to clicks outside of this element,
 * note that nesting this might cause unexpected behaviour
 */
const ClickOutside = ({ onClickOutside, children }) => {
  const [id] = useState(idGenerator.next().value);
  const outerListener = useCallback(
    (e) => {
      if (e.wasInnerClick !== id) {
        onClickOutside(e);
      }
    },
    [id, onClickOutside],
  );
  useEffect(() => {
    window.addEventListener('click', outerListener);
    return () => window.removeEventListener('click', outerListener);
  }, [id, outerListener]);

  return (
    <>
      {Children.map(children, (child) => {
        if (!child) {
          return null;
        }
        // make sure the original click handler is still triggered
        const { onClick } = child.props;
        return cloneElement(child, {
          onClick: (e) => {
            // bubbling event will not trigger outside listener when this is on there
            e.nativeEvent.wasInnerClick = id;

            if (typeof onClick === 'function') {
              onClick(e);
            }
          },
        });
      })}
    </>
  );
};

export default ClickOutside;
